var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"employees"}},[_c('Datatable',{staticClass:"datatable",attrs:{"entity":"employee","parameters":_vm.datatableParameters,"globalActions":_vm.datatableGlobalActions,"onRowClick":_vm.onRowEdit,"rowActions":[{text: 'datatable.edit', method: _vm.onRowEdit}]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }